export default "__VITE_ASSET__CmP0J9uT__"